(function (module) {
    'use strict';

    module.filter('secsToTime', () => {
        function padTime(t) {
            return t < 10 ? '0' + t : t;
        }

        return function (_seconds) {
            if (typeof _seconds !== 'number' || _seconds < 0)
                return '00:00:00';

            const hours = Math.floor(_seconds / 3600);
            const minutes = Math.floor((_seconds % 3600) / 60);
            const seconds = Math.floor(_seconds % 60);

            return padTime(hours) + ':' + padTime(minutes) + ':' + padTime(seconds);
        };
    });

})(angular.module('rocket.components'));
